export default __webpack_public_path__ + "static/media/profile.d4304654.svg";